export const url = 'https://scan.intruceptlabs.com/api/v1/auth';
export const Downloadurl = 'https://scan.intruceptlabs.com/api/v1/download';

//export const url = 'http://localhost/threatspotter-backend/public/api/v1/auth';
//export const Downloadurl = 'http://localhost/threatspotter-backend/public/api/v1/download';